module.exports = __webpack_public_path__ + "static/media/03-12.604967dd.png";